export default __webpack_public_path__ + "static/media/quality2.fbfb5aca.jpeg";